<template>
  <div class="cell grid-x">
    <div class="cell small-3 head left-light">
      {{ title }}
    </div>
    <div class="cell small-9 data clearfix">
      <job-preview-right-column
        :text-count-mode="textCountMode"
        :highlight-mode="highlightMode"
        comment-class="matching"
        :comment-highlights="commentHighlights"
        v-on="$listeners"
      />
      <slot name="body">
        <span
          :id="targetId"
          data-test="value"
          class="pega-break pega-pre-wrap"
          v-text=" value || '未登録' "
        />
      </slot>
      <slot />
    </div>
  </div>
</template>

<script>
import JobPreviewRightColumn from '@/components/molecules/JobPreviewRightColumn'
export default {
  components: {
    JobPreviewRightColumn
  },
  props: {
    title: {
      type: String,
      required: true
    },
    targetId: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    highlightMode: {
      type: Boolean,
      default: false
    },
    textCountMode: {
      type: Boolean,
      default: false
    }
  }
}
</script>
